export enum ServicerType {
  CDE = 'CDE',
  OGInternal = 'OGInternal',
  OSS = 'OSS',
  KeiyouGas = 'KeiyouGas',
  SeibuGas = 'SeibuGas'
}
